import { createContext } from 'react';

const userProcessContext = createContext();

export default userProcessContext;
